// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"135":"72d07d49","495":"74b2d484","867":"7b96c1f2"}[chunkId] + ".chunk.js";
};